import { ContentCategoryLinkList } from './content/category-link-list';
import { ContentFooterBar } from './content/footer-bar';
import { ContentIconLinkList } from './content/icon-link-list';
import { ContentInfo } from './content/info';
import { ContentProductLinkList } from './content/product-link-list';
import { ContentServiceLinkList } from './content/service-link-list';
import { Page } from './page';

/**
 * Model definition for footer
 */
export interface FlexFooter {
  __contentType: 'flex-footer';
  id: string;
  name?: string;
  pages?: Page[];
  content?: (
    | ContentCategoryLinkList
    | ContentFooterBar
    | ContentIconLinkList
    | ContentInfo
    | ContentProductLinkList
    | ContentServiceLinkList
  )[];
}

export function isFlexFooter(obj: { __contentType?: string }): obj is FlexFooter {
  return obj.__contentType === 'flex-footer';
}
